export function formatLabel(str, maxwidth) {
  var sections = []
  var words = str.split(" ")
  var temp = ""

  words.forEach(function (item, index) {
    if (temp.length > 0) {
      var concat = temp + " " + item

      if (concat.length > maxwidth) {
        sections.push(temp)
        temp = ""
      } else {
        if (index === words.length - 1) {
          sections.push(concat)
          return
        } else {
          temp = concat
          return
        }
      }
    }

    if (index === words.length - 1) {
      sections.push(item)
      return
    }

    if (item.length < maxwidth) {
      temp = item
    } else {
      sections.push(item)
    }
  })

  return sections
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export const chartColors = index => {
  const colors = [
    "#78BE20",
    "#009CDE",
    "#004C97",
    "#DA291C",
    "#F2A900",
    "#00B0B9",
  ]
  return colors[index] || "#000"
}

export const optionsStackedBar = {
  maintainAspectRatio: false,
  responsive: true,
  height: "medium",
  scales: {
    xAxes: [
      {
        stacked: true,
        gridLines: {
          display: false,
        },
      },
    ],
    yAxes: [
      {
        stacked: true,
        ticks: {
          beginAtZero: true,
          userCallback: function (value, index, values) {
            return value.toLocaleString()
          },
        },
      },
    ],
  },
  legend: {
    position: "top",
    labels: {
      boxWidth: 8,
      padding: 10,
      usePointStyle: true,
    },
    align: "start",
  },
}

export const optionsHorizontalBar = {
  maintainAspectRatio: false,
  height: "medium",
  scales: {
    xAxes: [
      {
        stacked: true,
        gridLines: {
          display: false,
        },
        ticks: {
          beginAtZero: true,
          userCallback: function (value, index, values) {
            return value.toLocaleString()
          },
        },
      },
    ],
    yAxes: [
      {
        stacked: true,
      },
    ],
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        return tooltipItem.value.toString().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
    },
  },
  legend: {
    display: false,
  },
}

export const optionsBarChart = {
  maintainAspectRatio: false,
  responsive: true,
  aspectRatio: 0.7,
  height: "auto",
  legend: {
    display: false,
  },
  tooltips: {
    callbacks: {
      title: function (tooltipItem, data) {
        let label = tooltipItem[0].label.replace(/,/g, " ")
        return label
      },
    },
  },
}
